const pickPropertiesFromObject = <V>(obj: V, keys: (keyof V)[]): Pick<V, (typeof keys)[number]> =>
  Object.fromEntries(keys.map((key) => [key, obj[key]])) as Pick<V, (typeof keys)[number]>;

export default pickPropertiesFromObject;
